module.exports = __webpack_public_path__ + "img/safe-harbor-ip.383c988e.svg";